// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"194":"384c3633","429":"d83c3fee","443":"0aa1270a","970":"3e7d533c"}[chunkId] + ".css";
};